import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Alert, EnumSpinnerLoaderPlacement, SpinnerLoader, Typography } from 'shared/ui'
import { TitledRow } from 'shared/ui/TitledRow/TitledRow'
import { getBillingLabel } from 'entities/Billing/lib/billingInterval'
import { PriceInfo } from 'entities/Billing'
import { type UrlShortenerModalStore } from 'pages/settings/pages/urlShortener/store/urlShortenerModalStore'

export type IActivateCustomDomainModalContentProps = {
  store: UrlShortenerModalStore
}

export const ActivateCustomDomainModalContent = observer(
  ({ store }: IActivateCustomDomainModalContentProps) => {
    const { isPaymentError } = store
    const brandedUrlShortenerTitle = store.priceInfoStore.priceInfoUiData ? (
      <TitledRow
        title={'Branded URL Shortener'}
        titleProps={{ color: 'var(--content-primary-primary)', variant: 'body-md-regular' }}
      >
        <Typography ariaLabel={'TierPrice'} variant={'body-md-regular'}>
          {`${store.priceInfoStore.priceInfoUiData.subtotal} / ${getBillingLabel(
            store.priceInfoStore.priceInfoUiData.interval
          )}`}
        </Typography>
      </TitledRow>
    ) : null

    useEffect(() => {
      void store.priceInfoStore.loadPriceData()
    }, [store])

    return (
      <>
        <Typography
          ariaLabel={'contactName'}
          variant={'heading-lg'}
          marginBottom={24}
          color={'var(--content-primary-primary)'}
        >
          Branded URL Shortener
        </Typography>

        {isPaymentError && (
          <Alert
            item={{
              type: 'error',
              title: 'We were unable to process your payment',
              desc: 'Please select a different card',
            }}
            marginBottom={32}
          />
        )}

        {!store.priceInfoStore.priceInfoUiData ? (
          <div style={{ minHeight: 200, position: 'relative' }}>
            <SpinnerLoader
              ariaLabel={'ActivateCustomDomainModalContent'}
              placement={EnumSpinnerLoaderPlacement.Center}
            />
          </div>
        ) : (
          <PriceInfo priceInfoStore={store.priceInfoStore} title={brandedUrlShortenerTitle} />
        )}
      </>
    )
  }
)
